import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { SharedClient } from '@kodit/core/data-api';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-prikaz-otpremnice-dropdown',
  templateUrl: './prikaz-otpremnice-dropdown.component.html',
  styleUrls: ['./prikaz-otpremnice-dropdown.component.scss'],
})
export class PrikazOtpremniceDropdownComponent implements OnInit {
  private _subs: Subscription = new Subscription();

  /** Props */
  items: SelectItem[] = [];

  /** I/O */
  @Input() formCtrl: AbstractControl;
  @Input() formCtrlId: string;
  @Input() parentCtrl: any = 'body';

  constructor(private _client: SharedClient) {}

  ngOnInit(): void {
    this._load();
  }

  private _load() {
    this._subs.add(
      this._client.getPrikazOtpremnice().subscribe((res) => {
        this.items = res.data.prikazOtpremniceDtoList.map((x) => ({
          value: x.prikazOtpremnice,
          label: x.prikazOtpremniceStr,
          title: x.opis,
        }));
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
